import React from 'react';

// 旧 ErrorModal.scss を内製化した Tailwind 定数。
// keyframes（fadeIn / slideIn）だけは Tailwind で表現できないため globals.css へ
// `em-` 接頭辞付きで移設した（無印の fadeIn / slideIn は styled-components 側が
// 各自インライン定義しており、名前を衝突させないため）。
const OVERLAY =
  'fixed top-0 left-0 w-full h-full bg-black/60 flex justify-center items-center z-[1000] ' +
  'animate-[em-fade-in_0.2s_ease-out]';
const DIALOG =
  'bg-white rounded-md shadow-[0_10px_25px_rgba(0,0,0,0.2)] w-[90%] max-w-[500px] max-h-[90vh] ' +
  'overflow-y-auto animate-[em-slide-in_0.3s_ease-out] max-[600px]:w-[95%] max-[600px]:max-h-[80vh]';
const HEADER =
  'p-4 border-b border-b-[#e0e0e0] flex justify-between items-center bg-[#f44336] text-white ' +
  'rounded-t-md';
const TITLE = 'm-0 text-[1.25rem] font-semibold max-[600px]:text-[1.1rem]';
const CLOSE_ICON =
  'bg-transparent border-none text-2xl cursor-pointer text-white leading-none p-0 m-0 w-7 h-7 ' +
  'flex items-center justify-center rounded-full transition-colors duration-200 hover:bg-white/20';
const BODY = 'p-4 max-h-[60vh] overflow-y-auto';
const MESSAGE = 'm-0 leading-[1.5] whitespace-pre-wrap break-words';
const FOOTER = 'p-4 border-t border-t-[#e0e0e0] flex justify-end';
const CLOSE_BUTTON =
  'px-4 py-2 bg-[#f44336] text-white border-none rounded font-semibold cursor-pointer ' +
  'transition-colors duration-200 hover:bg-[#EA1C0D]';

interface ErrorModalProps {
  show: boolean;
  title: string;
  message: string;
  onClose: () => void;
}

const ErrorModal: React.FC<ErrorModalProps> = ({ show, title, message, onClose }) => {
  if (!show) return null;

  return (
    <div className={OVERLAY} onClick={onClose}>
      <div className={DIALOG} onClick={(e) => e.stopPropagation()}>
        <div className={HEADER}>
          <h2 className={TITLE}>{title}</h2>
          <button className={CLOSE_ICON} onClick={onClose}>×</button>
        </div>
        <div className={BODY}>
          <p className={MESSAGE}>{message}</p>
        </div>
        <div className={FOOTER}>
          <button className={CLOSE_BUTTON} onClick={onClose}>閉じる</button>
        </div>
      </div>
    </div>
  );
};

export default ErrorModal;
